// Popup suppression state, shared by both placements. Cookies rather than storage: the
// registration flag must survive a storage clear and the daily window must outlive the session.

import {
  NEWSLETTER_POPUP_SHOWN_COOKIE,
  NEWSLETTER_POPUP_SHOWN_COOKIE_MAX_AGE,
  NEWSLETTER_REGISTERED_COOKIE,
  NEWSLETTER_REGISTERED_COOKIE_MAX_AGE,
} from "./newsletterContent"

const hasCookie = (name: string): boolean => {
  try {
    return document.cookie.split("; ").some((c) => c.startsWith(`${name}=`))
  } catch {
    return false
  }
}

const setCookie = (name: string, maxAgeSeconds: number): void => {
  try {
    document.cookie = `${name}=1; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`
  } catch {
    // Cookies unavailable — the popup will just show again next visit.
  }
}

export const hasRegistered = (): boolean => hasCookie(NEWSLETTER_REGISTERED_COOKIE)

export const markRegistered = (): void =>
  setCookie(NEWSLETTER_REGISTERED_COOKIE, NEWSLETTER_REGISTERED_COOKIE_MAX_AGE)

export const wasPopupShownToday = (): boolean => hasCookie(NEWSLETTER_POPUP_SHOWN_COOKIE)

export const markPopupShown = (): void =>
  setCookie(NEWSLETTER_POPUP_SHOWN_COOKIE, NEWSLETTER_POPUP_SHOWN_COOKIE_MAX_AGE)

export const isPopupSuppressed = (): boolean => hasRegistered() || wasPopupShownToday()
